import {
  CHECK_LOGIN_FAIL,
  CHECK_LOGIN_REQUEST,
  CHECK_LOGIN_SUCCESS,
  INVITED_USERS_LIST_FAIL,
  INVITED_USERS_LIST_REQUEST,
  INVITED_USERS_LIST_SUCCESS,
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_FAIL,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  REGISTER_FAIL,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_MAIL_SEND_FAIL,
  RESET_PASSWORD_MAIL_SEND_REQUEST,
  RESET_PASSWORD_MAIL_SEND_SUCCESS,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  USERS_LIST_FAIL,
  USERS_LIST_REQUEST,
  USERS_LIST_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  SIGNATURE_REQUEST,
  SIGNATURE_SUCCESS,
  SIGNATURE_FAIL,
  TENANT_USERS_LIST_REQUEST,
  TENANT_USERS_LIST_SUCCESS,
  TENANT_USERS_LIST_FAIL,
  VERIFY_DOMAIN_REQUEST,
  VERIFY_DOMAIN_SUCCESS,
  UPDATE_AVAILABLE_CREDITS,
  UPDATE_IS_SDR,
} from "../constants/authConstants";
import { axios } from "../../config";
import {
  authEndpoints,
  CampaignSettingsEndpoints,
  paymentEndpoints,
  REGISTRATION_LINK,
} from "../../utils/constants/httpConstants";
import CustomEventEmitter from "../../utils/emitter/EventEmitter";
import {
  EMITTER_ERROR,
  EMITTER_SUCCESS,
  SETTINGS_DATA_MANGEMENT_LIST,
  tenants_api_endpoints,
  SETTINGS_ACCOUNT_SETUP_LIST,
} from "../../utils/constants";
import { DEFAULT_ERROR_MESSAGE } from "../../utils/constants/messages";
import { POST, getRequest, postRequest } from "../../Apis/apiWrapper";
import {
  ACCESS_DENIED_PATH,
  BLOCKED_TENANT_ROUTE_PATH,
  DASHBOARD_PATH,
  EMAIL_MARKETING_CAMPAIGN_PATH,
  INITIAL_ROUTE,
  INVALID_TENANT_ROUTE_PATH,
  LOGIN_PATH,
  ONBOARDING_PAYMENT_CANCEL_PATH,
  ONBOARDING_PAYMENT_SUCCESS_PATH,
  PAYMENT_CANCEL_PATH,
  PAYMENT_SUCCESS_PATH,
} from "../../utils/constants/routes";
import { authRoutes } from "../../Router/authRoutes";

export const registerUser = (formdata) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_REQUEST });
    let response = await axios.post(`/${authEndpoints.register}`, formdata);
    dispatch({ type: REGISTER_SUCCESS, payload: response?.data });
  } catch (err) {
    err?.response?.status >= 500 &&
      CustomEventEmitter.emit(
        EMITTER_ERROR,
        err?.response?.data?.message || err?.message || "server error",
      );
    dispatch({ type: REGISTER_FAIL, payload: err?.response?.data });
  }
};

export const loginUser = (formdata) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });

    let response = await axios.post(`/${authEndpoints.login}`, formdata);

    dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
    CustomEventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
  } catch (err) {
    CustomEventEmitter.emit(
      EMITTER_ERROR,
      err?.response?.data?.message || err?.message || "Sever error",
    );

    dispatch({ type: LOGIN_FAIL, payload: err?.response?.data });
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    dispatch({ type: LOGOUT_REQUEST });

    let response = await axios.post(`/${authEndpoints.logout}`);

    localStorage.removeItem("tourOnboardingFetched");
    dispatch({ type: LOGOUT_SUCCESS, payload: response?.data });
    dispatch({
      type: LOGIN_FAIL,
      payload: { status: false, message: "User logged out" },
    });
    dispatch({
      type: CHECK_LOGIN_FAIL,
      payload: { status: false, message: "User logged out." },
    });

    CustomEventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
  } catch (err) {
    CustomEventEmitter.emit(
      EMITTER_ERROR,
      err?.response?.data?.message || err?.message || "Server error",
    );

    dispatch({ type: LOGOUT_FAIL, payload: err?.response?.data });
  }
};

// Refresh Token
export const checkLogin = (navigate) => async (dispatch) => {
  try {
    console.log(
      "[checkLogin Action] Starting checkLogin with navigate?",
      !!navigate,
    );
    dispatch({ type: CHECK_LOGIN_REQUEST });

    // endpoint request here
    const response = await POST(authEndpoints.checkLogin, {}, navigate);
    console.log("[checkLogin Action] Response Data:", response.data);

    dispatch({ type: CHECK_LOGIN_SUCCESS, payload: response.data });
    await dispatch(userDetails(response.data.data));
    dispatch(tenantUsersDetail(navigate));

    // If refresh-token response itself includes isSdr, set it immediately
    const loginData = response.data.data;
    if (loginData?.isSdr === true || loginData?.isSdr === "true") {
      dispatch({ type: UPDATE_IS_SDR, payload: true });
    }

    // Fetch credit/SDR status early so the header shows correct info
    try {
      const [creditRes, subRes] = await Promise.all([
        getRequest(navigate, paymentEndpoints.creditUsage).catch(() => null),
        getRequest(navigate, paymentEndpoints.currentSubscription).catch(() => null),
      ]);

      // Check isSdr from credit usage API (boolean)
      const creditData = creditRes?.data?.data;
      if (creditData) {
        dispatch({
          type: UPDATE_AVAILABLE_CREDITS,
          payload: creditData.remaining_credits,
        });
        if (creditData.isSdr === true || creditData.isSdr === "true") {
          dispatch({ type: UPDATE_IS_SDR, payload: true });
        }
      }

      // Check isSdr from subscription metadata (string "true")
      const subData = subRes?.data?.data;
      if (subData?.has_subscription) {
        const sdrFlag = subData.subscription?.metadata?.isSdr;
        if (sdrFlag === true || sdrFlag === "true") {
          dispatch({ type: UPDATE_IS_SDR, payload: true });
        }
      }
    } catch (e) {
      // Non-critical - silently fail
    }

    const userData = response.data.data;
    console.log("[checkLogin Action] User Setup Status:", {
      has_subscription: userData?.has_subscription,
      account_setting_setup: userData?.account_setting_setup,
      general_setting_setup: userData?.general_setting_setup,
    });

    // ── admin-sdr LANDING — deliberately OUTSIDE the setup gate below ────────
    // An SDR must land on the DASHBOARD on login, and must never be dropped on
    // /user/access-denied or pushed into onboarding. This has to run before the
    // `account_setting_setup && general_setting_setup` gate, NOT inside it:
    // blazent's SDR has general_setting_setup === false, so that gate is false
    // and everything inside it never executed for the only admin-sdr user there.
    // checkLogin then fell through to the else branch -> navigate(INITIAL_ROUTE),
    // and the Router's SDR guard bounced that forbidden path to access-denied.
    // That — not a race, and not the Router guard — was the real cause of
    // "logging in as admin-sdr opens /user/access-denied" (blazent, 2026-08-17).
    //
    // Returning early is required: the admin-user branch further down does
    // navigate(window.location.pathname + search), which would re-restore the
    // very path we just moved them off. Every dispatch that matters
    // (CHECK_LOGIN_SUCCESS, userDetails, tenantUsersDetail, isSdr, credits) has
    // already run above, so nothing is skipped.
    //
    // ACCESS_DENIED_PATH is intentionally absent from this list while
    // Router/index.js DOES allow it — that asymmetry is what makes "login goes
    // to the dashboard" and "clicking a forbidden tab shows access-denied" both
    // true at once. Do not align the two lists.
    // On a FRESH load the destination depends on where they came in:
    //   "/" (i.e. a login)        -> dashboard
    //   an allowed path            -> stay
    //   /user/access-denied        -> dashboard, never leave them stranded there
    //                                 (a refresh on that screen used to replay it)
    //   ANY other path             -> access-denied, because typing a forbidden
    //                                 url by hand is still "opening a path" and
    //                                 must be refused visibly, not redirected
    //                                 away silently
    //   Stripe return pages        -> untouched
    if (userData?.role_access === "admin-sdr") {
      const currentPath = window.location.pathname;
      const sdrAllowedPaths = [DASHBOARD_PATH, EMAIL_MARKETING_CAMPAIGN_PATH];
      // exact list, not a substring test — "includes('payment')" would let any
      // url containing that word through
      const isPaymentReturn = [
        PAYMENT_SUCCESS_PATH,
        PAYMENT_CANCEL_PATH,
        ONBOARDING_PAYMENT_SUCCESS_PATH,
        ONBOARDING_PAYMENT_CANCEL_PATH,
      ].includes(currentPath);

      if (currentPath.startsWith("/auth") || isPaymentReturn) {
        return;
      }
      const onAllowedPath = sdrAllowedPaths.some(
        (path) => currentPath === path || currentPath.startsWith(path + "/"),
      );
      if (onAllowedPath) return;

      const target =
        currentPath === "/" || currentPath === ACCESS_DENIED_PATH
          ? DASHBOARD_PATH
          : ACCESS_DENIED_PATH;
      console.log(
        "[checkLogin Action] admin-sdr landing ->",
        target,
        "(was:",
        currentPath,
        ")",
      );
      if (navigate) navigate(target);
      return;
    }

    if (userData?.account_setting_setup && userData?.general_setting_setup) {
      console.log("[checkLogin Action] Setup Complete. Path checking...");
      const role = userData?.role;

      if (role !== "admin-user") {
        // check for protected routes.
        const protected_path_ids = [
          ...SETTINGS_DATA_MANGEMENT_LIST.map((item) => item.id),
          ...SETTINGS_ACCOUNT_SETUP_LIST.map((item) => item.id),
        ];
        for (let i in protected_path_ids) {
          if (window.location.search.includes(protected_path_ids[i])) {
            console.log(
              "[checkLogin Action] Protected route detected, redirecting to Dashboard",
            );
            if (navigate) navigate(DASHBOARD_PATH);
            break;
          }
        }

        // check for root URL.
        if (window.location.pathname === "/" && navigate) {
          console.log(
            "[checkLogin Action] Root path detected, redirecting to Dashboard",
          );
          navigate(DASHBOARD_PATH);
        }
      } else {
        const validAuthRoutes = [...authRoutes.map((item) => item.path), "/"];
        if (navigate) {
          console.log(
            "[checkLogin Action] Admin user or fallback, deciding path...",
          );
          validAuthRoutes.includes(window.location.pathname)
            ? navigate(DASHBOARD_PATH)
            : navigate(window.location.pathname + window.location.search);
        }
      }
    } else {
      console.log("[checkLogin Action] Setup INCOMPLETE. Onboarding check...");

      const isPaymentResultPage =
        window.location.pathname.includes("payment/success") ||
        window.location.pathname.includes("payment/cancel");

      if (
        navigate &&
        window.location.pathname !== INITIAL_ROUTE &&
        !isPaymentResultPage
      ) {
        console.log(
          "[checkLogin Action] Not on INITIAL_ROUTE, redirecting to Onboarding",
        );
        navigate(INITIAL_ROUTE);
      } else {
        console.log(
          "[checkLogin Action] Staying put to let component handle redirect.",
        );
      }
    }
  } catch (err) {
    console.error("[checkLogin Action] Error in checkLogin:", err);
    // if called from login page, then don't emit this message.
    dispatch({ type: CHECK_LOGIN_FAIL, payload: err });
    if (navigate) {
      navigate(LOGIN_PATH);
    }
  }
};

// Refresh Token
export const tenantUsersDetail = (navigate) => async (dispatch, getState) => {
  try {
    let apiDetails = {};
    dispatch({ type: TENANT_USERS_LIST_REQUEST });
    tenants_api_endpoints?.forEach(async (item) => {
      // if endpoint exists.
      if (item?.endpoint) {
        var response;
        if (item?.type === "post") {
          response = await postRequest(navigate, item?.endpoint, {});
        } else {
          response = await getRequest(navigate, item?.endpoint);
        }
        apiDetails = { ...apiDetails, [item?.id]: { ...response } };
        dispatch({
          type: TENANT_USERS_LIST_SUCCESS,
          payload: {
            ...apiDetails,
          },
        });
      }
      // if action exists, it will store data into its reducer.
      else {
        dispatch(item?.action({}, navigate));
      }
    });
  } catch (err) {
    // if called from login page, then don't emit this message.
    console.log("Response erro ", err);
    dispatch({ type: TENANT_USERS_LIST_FAIL, payload: err });
  }
};

export const userDetails = (payload) => async (dispatch) => {
  try {
    dispatch({ type: USER_DETAILS_REQUEST });
    dispatch({ type: USER_DETAILS_SUCCESS, payload: payload });
  } catch (err) {
    dispatch({ type: USER_DETAILS_FAIL, payload: err });
  }
};

export const updateAvailableCredits = (navigate) => async (dispatch) => {
  try {
    // const response = await getRequest(navigate, paymentEndpoints.billingPlan);
    // if (response?.data?.status && response?.data?.data) {
    //   const credits = response.data.data.available_credits;
    //   dispatch({
    //     type: UPDATE_AVAILABLE_CREDITS,
    //     payload: credits,
    //   });
    // }

    // Fetch most accurate credits from creditUsage API
    const creditRes = await getRequest(navigate, paymentEndpoints.creditUsage);
    if (creditRes?.data?.status && creditRes?.data?.data) {
      const creditData = creditRes.data.data;
      const credits = creditData.remaining_credits;
      dispatch({
        type: UPDATE_AVAILABLE_CREDITS,
        payload: credits,
      });
      // Check isSdr from credit usage API
      if (creditData.isSdr === true || creditData.isSdr === "true") {
        dispatch({ type: UPDATE_IS_SDR, payload: true });
      }
    }

    // Hit current-plan (billingPlan) API after credit usage API
    await getRequest(navigate, paymentEndpoints.billingPlan);
  } catch (err) {
    console.error("Error updating credits:", err);
  }
};

export const verifyDomain =
  (subDomain, navigate = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: VERIFY_DOMAIN_REQUEST });
      // endpoint request here
      const response = await axios.post(authEndpoints.verifyDomain, {
        sub_domain: subDomain,
      });
      dispatch({ type: VERIFY_DOMAIN_SUCCESS, payload: response.data });
    } catch (err) {
      if (err?.response?.status === 422) {
        setTimeout(() => {
          window.location.href = REGISTRATION_LINK;
        }, 1000);
      } else if (err?.response?.status === 419) {
        navigate(INVALID_TENANT_ROUTE_PATH);
      } else if (err?.response?.status === 420) {
        navigate(BLOCKED_TENANT_ROUTE_PATH);
      } else {
        CustomEventEmitter.emit(
          EMITTER_ERROR,
          err?.response?.data?.message || err?.message || DEFAULT_ERROR_MESSAGE,
        );
      }
      // dispatch({ type: RESET_PASSWORD_FAIL, payload: err?.response?.data });
      throw err;
    }
  };
// Forgot password action

export const resetPasswordMailSend =
  (email, reset = false) =>
  async (dispatch) => {
    if (reset) {
      dispatch({
        type: RESET_PASSWORD_MAIL_SEND_SUCCESS,
        payload: null,
      });
    } else {
      try {
        dispatch({ type: RESET_PASSWORD_MAIL_SEND_REQUEST });
        let response = await axios.post(
          authEndpoints.sendMailForResetPassword,
          {
            email: email,
          },
        );
        dispatch({
          type: RESET_PASSWORD_MAIL_SEND_SUCCESS,
          payload: response.data,
        });
      } catch (err) {
        dispatch({
          type: RESET_PASSWORD_MAIL_SEND_FAIL,
          payload: err?.response?.data,
        });
      }
    }
  };

export const resetPassword = (formdata, navigate) => async (dispatch) => {
  try {
    dispatch({ type: RESET_PASSWORD_REQUEST });

    // endpoint request here
    const response = await axios.post(authEndpoints.resetPassword, formdata);
    dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response });
    CustomEventEmitter.emit(
      EMITTER_SUCCESS,
      response?.data?.message || "password updated",
    );

    dispatch(userDetails(response?.data?.data));
    navigate(DASHBOARD_PATH);
  } catch (err) {
    console.log(err, "err");
    //invalid token error showed on emiiter not tested yet

    {
      //after discuss with vishal applying this. If condition
      if (!err?.response?.data?.message == "Invalid data provided") {
        CustomEventEmitter.emit(EMITTER_ERROR, err?.response?.data?.message);
      }
    }

    if (err?.response?.status === 403) {
      CustomEventEmitter.emit(EMITTER_SUCCESS, err?.response?.data?.message);
      navigate(LOGIN_PATH);
    }

    dispatch({ type: RESET_PASSWORD_FAIL, payload: err?.response?.data });
  }
};

// User Invitaion and users actions

export const invitedUsersList = (navigate) => async (dispatch) => {
  try {
    dispatch({ type: INVITED_USERS_LIST_REQUEST });
    const response = await getRequest(navigate, authEndpoints.invitedUsersList);

    dispatch({
      type: INVITED_USERS_LIST_SUCCESS,
      payload: response?.data,
    });
  } catch (err) {
    if (err?.status === 401) {
      navigate(LOGIN_PATH);
    }

    dispatch({ type: INVITED_USERS_LIST_FAIL, payload: err });
  }
};

export const usersList = (navigate) => async (dispatch) => {
  try {
    dispatch({ type: USERS_LIST_REQUEST });
    const response = await getRequest(navigate, authEndpoints.userList);

    dispatch({
      type: USERS_LIST_SUCCESS,
      payload: response?.data,
    });
  } catch (err) {
    if (err?.status === 401) {
      navigate(LOGIN_PATH);
    }

    dispatch({ type: USERS_LIST_FAIL, payload: err });
  }
};
export const getSignatureAction = (navigate) => async (dispatch) => {
  try {
    dispatch({ type: SIGNATURE_REQUEST });
    const response = await getRequest(
      navigate,
      CampaignSettingsEndpoints.getSignature,
    );
    dispatch({ type: SIGNATURE_SUCCESS, payload: response?.data });
  } catch (error) {
    if (error?.status === 401) {
      navigate(LOGIN_PATH);
    }
    dispatch({ type: SIGNATURE_FAIL, payload: error });
  }
};
